import { Button } from '@/components/ui/button';
import { Twitter, ExternalLink } from 'lucide-react';

/**
 * ShareToX - Simple Twitter/X sharing using Web Intent (no API key needed!)
 * Opens Twitter's share dialog with pre-filled text
 */
const ShareToX = ({ 
  text, 
  url = '', 
  hashtags = ['NightBuZz', 'NightOut'],
  buttonText = 'Share to X',
  variant = 'default',
  size = 'default',
  className = ''
}) => {
  
  const handleShare = () => {
    // Build Twitter Web Intent URL
    const baseUrl = 'https://twitter.com/intent/tweet';
    const params = new URLSearchParams();
    
    if (text) params.append('text', text);
    if (url) params.append('url', url);
    if (hashtags && hashtags.length > 0) {
      params.append('hashtags', hashtags.join(','));
    }
    
    const shareUrl = `${baseUrl}?${params.toString()}`;
    
    // Open in new window (mobile-friendly size)
    window.open(
      shareUrl,
      'twitter-share',
      'width=550,height=420,scrollbars=yes'
    );
  };

  return (
    <Button
      onClick={handleShare}
      variant={variant}
      size={size}
      className={`bg-black hover:bg-gray-900 text-white ${className}`}
    >
      <Twitter className="w-4 h-4 mr-2" />
      {buttonText}
      <ExternalLink className="w-3 h-3 ml-1 opacity-60" />
    </Button>
  );
};

/**
 * Quick share function - can be used anywhere without the component
 */
export const shareToTwitter = (text, url = '', hashtags = []) => {
  const baseUrl = 'https://twitter.com/intent/tweet';
  const params = new URLSearchParams();
  
  if (text) params.append('text', text);
  if (url) params.append('url', url);
  if (hashtags && hashtags.length > 0) {
    params.append('hashtags', hashtags.join(','));
  }
  
  window.open(
    `${baseUrl}?${params.toString()}`,
    'twitter-share',
    'width=550,height=420,scrollbars=yes'
  );
};

export default ShareToX;
